<template>
  <section id="default-page-template">
    <div class="coverPhoto" style="background-image: url(img/about-bg.jpg)">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-8">
            <div class="header-title">
              <h2>
              Të gatshëm në çdo moment për
              <span>bartje</span>
            </h2>
            </div>
          </div>
        </div>
      </div> 
    </div>  
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="white-content">
            <h4>Më shumë për ne</h4>
            <p>
              MARIMANGA është kompani për autobartje e cila operon në Kosovë dhe në Bashkimin Evropian. Marimanga është themeluar në vitin 2007 dhe është pjesë e Besa Group.
              
              Nga viti 2010 Marimanga ka filluar të ofroj sigurime vjetore të autobartjës në Kosovë.
              Në vitin 2019 Marimanga ka ridizajnuar këtë model dhe ka aplikuar formën e re të <strong>“ANËTARËSIM VJETOR”</strong> e cila tash është në platformën online me 3 pako bazë: Kosova, Ballkani dhe Evropa
            </p>
            <h4>Misioni i Marimangës</h4>
            <p>Misioni i "Marimanga" është ofrimi sa më kualitativ i shërbimeve të autobartjës dhe në mënyrë profesionale, duke plotësuar kërkesat e të gjithë klientëve.</p>
            <h4>Vizioni i Marimangës</h4>
            <p>Vizioni i "Marimanga" është qëndrimi në tregun Kosovar si lider për shërbime të autobartjës, si kompania më e avancuar dhe më moderne në këtë lami.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
export default {
  name: "AboutUs"
};
</script>
